import './App.css';
import HomeScreen from './screens/HomeScreen';

function App() {
  return (
    <div>
      <HomeScreen />
    </div>
  );
}

export default App;
